import { useState, useEffect } from 'react';
import * as React from 'react';

//React Router
import { Navigate, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom' //useParams to get the ref transmitted in the url

import dayjs from 'dayjs';

//created components
import HeaderStep from "../../../commons/headerstep/HeaderStep.jsx";
import BannerMoutchicLoisirs from "../../../commons/bannerMoutchicLoisirs/BannerMoutchicLoisirs.jsx";
import ManagerNavBar from "../../../components/managernavbar/ManagerNavBar.jsx"; //<ManagerNavBar idSpotLoc={idSpotLoc} />
import HeaderStepManager from "../../../commons/headerstepmanager/HeaderStepManager.jsx";
import ModalContrat from "../../../components/modalcontrat/ModalContrat.jsx";



//MUI Components
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';


//Redux tools and hooks
import { useSelector, useDispatch } from "react-redux";
import { getIdSpotLoc } from "../../../store/selectors.js";

//Utils
import { checkLogin } from '../../../utils/check-login.js'
//import Fetch API functions
import { getArticles, getAllContratsSearch, getAccessoires } from '../../../database/fetchApi.js'


function ManagerSearch() { // component to manage the first step of shopping : choosing place and time

    const navigate = useNavigate();
    const [articles, setArticles] = useState([]);
    const [accessoires, setAccessoires] = useState([]);
    const [contrats, setContrats] = useState([]);
    const [spotFilter, setSpotFilter] = useState(0);
    const [contratId, setContratId] = useState(0);
    const [triMode, setTriMode] = useState("nom");
    const [currentContrat, setCurrentContrat] = useState();
    const [keyword, setKeyword] = useState("");
    let idSpotLoc = useSelector(getIdSpotLoc);

    const [open, setOpen] = React.useState(false);
    const handleOpen = (id) => {
        setOpen(true);
        setContratId(id);
        setCurrentContrat(contrats.filter((contrat) => contrat.id_contrat === id)[0]);
    };

    const handleClose = () => setOpen(false);


    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        if (checkLogin() === false) {
            navigate("/manager/login/search");
        }; // if no login, no token, go to login page

        async function initArticles() { //we add this inner function to manage asynchrone
            let allArticles = await getArticles();
            setArticles([].concat(allArticles))
        } //end of async function
        initArticles(); //call the inner asnchrone function

        async function initAccess() { //we add this inner function to manage asynchrone
            let allAccess = await getAccessoires();
            setAccessoires(allAccess)
        } //end of async function
        initAccess(); //call the inner asnchrone function



        initContrats(keyword || "oipp344"); //call the inner asnchrone function

    }, [])

    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        if (open === false) {
            console.log("refresh after closing");
            initContrats(keyword);
        }

    }, [open])

    /*  useEffect(() => { //get current contrat by click on table line
 
         setCurrentContrat(contrats.filter((contrat) => contrat.id_contrat === contratId)[0]);
         console.log(currentContrat);
     }, [contratId]) */


    async function initContrats(word) { //we add this inner function to manage asynchrone
        let allContrats = await getAllContratsSearch(word);
        //keep only the paid contrats
        setContrats([].concat(allContrats.filter((contrat) => contrat.paye > 0)))
    } //end of async function

    contrats && contrats.sort((c1, c2) => chrono(c1, c2));
    console.log(contrats);
    //// filter the contrats ifa filter is spot is chosen, or keep all contrats
    let filteredContrats = spotFilter === 0 ? contrats : contrats.filter((contrat) => contrat.spot_id === spotFilter);


    function chrono(contrat1, contrat2) {
        let debut1 = dayjs(contrat1.date1);
        let debut2 = dayjs(contrat2.date1);
        return debut1.isAfter(debut2, "day") ? 1 : -1;
    }

    function prepDate(date, heure) {
        return dayjs(date).format("DD/MM") + " : " + heure + "h00";
    }

    function getQteArticles(articles) {
        let qte = 0;
        articles.forEach((article) => { qte += article.qte })
        return qte;
    }

    function getContratPasse(date) {
        let className = "list-contrat-tableau-ligne";
        className += dayjs().isAfter(dayjs(date), "day") ? " list-contrat-tableau-ligne-passee" : "";

        return className;

    }
    function getSpotInfos(contrat) {

        if (contrat.livraison === true) {
            return (["Livraison:", contrat.adresse_livraison]);
        }
        else {
            return ([contrat.Spot.nom_spot, contrat.Spot.adresse_spot]);
        }
    }

    function getDetailsArticles(article) {
        let details = "";
        details += String(article.qte) + " x  ";
        let typeArticle = articles.find((art) => art.id_article === article.article_id).type;
        details += typeArticle;
        return details
    }

    function getTaillesArticles(article) {
        let tailles = "";
        article.taille.forEach((taille, index) => {
            if (taille !== "0") {
                tailles += article.prenom[index] + " : " + taille + "cm  / "
            }
        })
        return tailles
    }

    function searchContrat() {
        setSpotFilter(0);
        initContrats(keyword);
    }

    function contratsSorter(list) {
        let newList = [];

        switch (triMode) {
            case "nom":
                // code block
                newList = list.toSorted((c1, c2) => c1.Client.nom.toLowerCase() > c2.Client.nom.toLowerCase())
                break;
            case "tarif":
                // code block
                newList = list.toSorted((c1, c2) => c1.total > c2.total)
                break;
            case "crea":
                // code block
                newList = list.toSorted((c1, c2) => dayjs(c1.created).isAfter(dayjs(c2.created), "day"))
                break;
            case "debut":
                // code block
                newList = list.toSorted((c1, c2) => dayjs(c1.date1).isAfter(dayjs(c2.date1), "day"))
                break;
            case "fin":
                // code block
                newList = list.toSorted((c1, c2) => dayjs(c1.date2).isAfter(dayjs(c2.date2), "day"))
                break;
            case "type":
                // code block
                newList = list.toSorted((c1, c2) => c1.resa === true && c2.resa === false)
                break;
            default:
            // code block
        }


        return newList
    }

    return (
        <main>
            <BannerMoutchicLoisirs title={"Manager : Outil de réservation de vélos"} />
            <ManagerNavBar idSpotLoc={idSpotLoc} />
            <HeaderStepManager title={"Recherche Contrats"} />

            <div className="manager-search">
                <div className="manager-search-zone-recherche">

                    <div className="manager-search-zone-recherche-left">


                        <TextField
                            size="small"
                            placeholder="nom, prenom, ref. Contrat, spot"
                            value={keyword}
                            onChange={e => setKeyword(e.target.value)}
                        />

                        <Button
                            disabled={false/* Keyword.length === 0 */}
                            className="bouton-valid-cmd"
                            variant="contained"
                            onClick={_ => searchContrat()}
                        >chercher
                </Button>
                    </div>
                    <div className="manager-search-zone-recherche-right">


                        <FormControlLabel
                            className="manager-jour-top-spot-checkbox"
                            /* required */
                            control={<Checkbox

                                onChange={_ => setKeyword(keyword === "touslescontrats" ? "" : "touslescontrats")}
                                checked={keyword === "touslescontrats"}
                            />}
                            label="Tous les contrats"

                        />
                    </div>
                </div>

            </div>

            {contrats.length < 1 ?
                /* keyword && keyword.length > 0 ?
                    <CircularProgress />
                    : null */
                <p>Aucun contrat à afficher</p>
                :
                <div className="list-contrat">
                    <div className="list-contrat-spot-filter">
                        <h3>Filtre par point de location : </h3>
                        <div className="list-contrat-spot-filter-boutons">
                            <p onClick={_ => setSpotFilter(0)}>Tous</p>
                            <p onClick={_ => setSpotFilter(1)}>Moutchic plage</p>
                            <p onClick={_ => setSpotFilter(2)}>Atelier Moutchic</p>
                            <p onClick={_ => setSpotFilter(3)}>Goelia, Marina Talaris</p>
                            <p onClick={_ => setSpotFilter(4)}>Le Tedey</p>
                            <p onClick={_ => setSpotFilter(5)}>Bernos</p>
                            <p onClick={_ => setSpotFilter(99)}>Livraison</p>
                        </div>
                    </div>



                    <Table className="list-contrat-tableau">
                        <TableHead>
                            <TableRow className="list-contrat-tableau-head">
                                <TableCell>spot</TableCell>
                                <TableCell className={triMode === "type" ? "manager-search-tableau-header header-selected" : "manager-search-tableau-header"} align="right" onClick={_ => setTriMode("type")}><p>{triMode === "type" ? <ArrowDropUpIcon /> : null}Type</p></TableCell>
                                <TableCell className={triMode === "debut" ? "manager-search-tableau-header header-selected" : "manager-search-tableau-header"} align="right" onClick={_ => setTriMode("debut")}><p>{triMode === "debut" ? <ArrowDropUpIcon /> : null}Début</p></TableCell>
                                <TableCell className={triMode === "fin" ? "manager-search-tableau-header header-selected" : "manager-search-tableau-header"} align="right" onClick={_ => setTriMode("fin")}><p>{triMode === "fin" ? <ArrowDropUpIcon /> : null}Fin</p></TableCell>
                                <TableCell className={triMode === "crea" ? "manager-search-tableau-header header-selected" : "manager-search-tableau-header"} align="right" onClick={_ => setTriMode("crea")}><p>{triMode === "crea" ? <ArrowDropUpIcon /> : null}Créa</p></TableCell>
                                <TableCell className={triMode === "nom" ? "manager-search-tableau-header header-selected" : "manager-search-tableau-header"} align="right" onClick={_ => setTriMode("nom")}><p>{triMode === "nom" ? <ArrowDropUpIcon /> : null}Client</p></TableCell>
                                <TableCell className={triMode === "tarif" ? "manager-search-tableau-header header-selected" : "manager-search-tableau-header"} align="right" onClick={_ => setTriMode("tarif")}><p>{triMode === "tarif" ? <ArrowDropUpIcon /> : null}Tarif</p></TableCell>
                                <TableCell align="right">Qte articles</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                contratsSorter(filteredContrats).map((contrat) => (
                                    <TableRow
                                        className={" "/* getContratPasse(contrat.date1) */}
                                        key={contrat.id_contrat}
                                        onClick={_ => (handleOpen(contrat.id_contrat))}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <TableCell component="th" scope="row" className={"manager-search-tableau-ligne-spot-color" + contrat.spot_id}>
                                            {contrat.Spot.nom_spot}
                                        </TableCell>
                                        <TableCell align="right">{contrat.resa === true ? "Résa" : "Contrat"}</TableCell>
                                        <TableCell align="right">{prepDate(contrat.date1, contrat.h1)}</TableCell>
                                        <TableCell align="right">{prepDate(contrat.date2, contrat.h2)}</TableCell>
                                        <TableCell align="right">{dayjs(contrat.created).format("DD/MM")}</TableCell>
                                        <TableCell align="right">{contrat.Client.nom + " " + contrat.Client.prenom}</TableCell>
                                        <TableCell align="right">{contrat.total + ",00€"}</TableCell>
                                        <TableCell align="right">{getQteArticles(contrat.ContratArticles)}</TableCell>
                                    </TableRow>
                                ))
                            }

                        </TableBody>
                    </Table>

                </div>

            }
            {currentContrat &&
                <Modal
                    open={open}
                    onClose={handleClose}
                >
                    <ModalContrat currentContrat={currentContrat} articles={articles} accessoires={accessoires} setOpen={setOpen} />
                </Modal>
            }

        </main>
    )
}




export default ManagerSearch